import * as React from 'react';
import RPT from 'prop-types';
import Radium from 'radium';
import { Button, ButtonToolbar } from 'react-bootstrap';
import { connect } from 'react-redux';

import { selectForOrder } from '../order/actions';

const userPropType = RPT.shape({
  id: RPT.number.isRequired,
  first_name: RPT.string.isRequired,
  last_name: RPT.string
});

@connect(null, { selectForOrder })
@Radium
export default class Workshop extends React.Component {
  static propTypes = {
    id: RPT.number.isRequired,
    styles: RPT.object.isRequired, // eslint-disable-line react/forbid-prop-types
    annotation: RPT.string.isRequired,
    name: RPT.string.isRequired,
    guarantor: userPropType,
    team_members: RPT.arrayOf(userPropType).isRequired,
    selectForOrder: RPT.func.isRequired
  }

  static defaultProps = {
    guarantor: null
  };

  constructor(...args) {
    super(...args);
    this.state = {
      open: false
    };
  }

  guarantorName() {
    const { guarantor } = this.props;
    return [guarantor.first_name, guarantor.last_name].filter(name => name).join(' ');
  }

  handleOrdered() {
    const { id, selectForOrder } = this.props;

    selectForOrder(id);
  }

  render() {
    const { styles, annotation, name, guarantor, team_members: teamMembers, id } = this.props;

    return (
      <div className="panel" style={styles.panel}>
        <div className="panel-heading" style={styles.heading}>{name}</div>
        <div className="panel-body" style={styles.body}>
          {annotation}
          <div className={!this.state.open && 'hidden'}>
            {guarantor &&
              [<h4 key={`workshop-${id}-guarantor`}>{`Garant tématu - ${this.guarantorName()}`}</h4>,
                guarantor.bio]
            }

            { teamMembers &&
              [<h4 key={`workshop-${id}-rt`}>Realizační tým</h4>,
                <ul key={`workshop-${id}-rt-list`}style={{ listStyleType: 'circle' }}>
                  {teamMembers.map(member =>
                    <li key={`member-${member.id}`}>{`${member.first_name} ${member.last_name}`}</li>
                  )}
                </ul>
              ]
           }
          </div>

          <ButtonToolbar style={styles.toolbar}>
            <Button
              bsSize="sm"
              onClick={() => this.setState({ open: !this.state.open })}
              style={styles.button}
            >
              <i className={this.state.open ? 'fa fa-angle-double-up' : 'fa fa-angle-double-down'} />
              {this.state.open ? ' Méně informací' : ' Více informací'}
            </Button>

            <Button onClick={this.handleOrdered.bind(this)} bsSize="sm" bsStyle="primary" style={styles.button}>
              <i className="fa fa-envelope" />
              &nbsp;Objednat workshop
            </Button>
          </ButtonToolbar>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/Feature/workshopcategorypage/workshop.jsx